import { z } from "zod";

import { ERROR_TYPE } from "@/utils";

const { REQUIRED } = ERROR_TYPE;

export const CompanyBalanceSchema = z.object({
	id: z.number().optional(),
	value: z.string().min(1, { message: REQUIRED }),
});

export const CreateCompanyBalanceSchema = z.object({
	value: z.string().min(1, { message: REQUIRED }),
});

export const UpdateCompanyBalanceSchema = z.object({
	id: z.number(),
	value: z.string().min(1, { message: REQUIRED }),
});

export const DeleteCompanyBalanceSchema = z.object({
	id: z.number(),
});

export const CompanyBalanceArraySchema = z.array(CompanyBalanceSchema);

export type CompanyBalance = z.infer<typeof CompanyBalanceSchema>;
export type CreateCompanyBalance = z.infer<typeof CreateCompanyBalanceSchema>;
export type UpdateCompanyBalance = z.infer<typeof UpdateCompanyBalanceSchema>;
export type DeleteCompanyBalance = z.infer<typeof DeleteCompanyBalanceSchema>;
export type CompanyBalanceArray = z.infer<typeof CompanyBalanceArraySchema>;
